(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire0d69"];
var parcelRegister = parcelRequire.register;
parcelRegister("aRU3u", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7e9a5606323638c3$export$2e2bcd8739ae039; });
var $7e9a5606323638c3$var$anchorContent = function() {
    var detectCurrentAnchorContent = function detectCurrentAnchorContent() {
        var scrollDistance = document.documentElement.scrollTop + 25;
        $(".c-anchored-content").each(function() {
            var component = $(this);
            var sidebar = component.find(".c-anchored-content__sidebar-links");
            var sidebarHeight = sidebar.outerHeight();
            var sidebarwidth = component.find(".c-anchored-content__sidebar").innerWidth();
            var componentTop = component.offset().top;
            var componentHeight = component.outerHeight();
            var componentBottom = componentTop + componentHeight;
            var componentLeft = component.offset().left;
            if (scrollDistance < componentTop) {
                component.find(".js-anchor-labels").removeClass("is-active");
                component.find(".js-anchor-labels").first().addClass("is-active");
            } else if (scrollDistance > componentBottom) {
                component.find(".js-anchor-labels").removeClass("is-active");
                component.find(".js-anchor-labels").last().addClass("is-active");
            }
            if (scrollDistance > componentTop && scrollDistance + sidebarHeight <= componentBottom) sidebar.css({
                position: "fixed",
                width: sidebarwidth + "px",
                top: "25px",
                bottom: "auto"
            });
            else if (scrollDistance + sidebarHeight > componentBottom) sidebar.css({
                position: "absolute",
                top: "auto",
                bottom: "0"
            });
            else sidebar.css({
                position: "absolute",
                top: "0",
                bottom: "auto"
            });
            component.find(".js-anchor-sections").each(function() {
                var section = $(this);
                var sectionTop = section.offset().top - 100;
                var sectionHeight = section.outerHeight();
                var sectionBottom = sectionTop + sectionHeight;
                if (scrollDistance > sectionTop && scrollDistance <= sectionBottom) {
                    var targetAnchor = section.attr("id");
                    component.find(".js-anchor-labels").removeClass("is-active");
                    $('a[href="#' + targetAnchor + '"]').addClass("is-active");
                }
            });
        });
    };
    document.addEventListener("scroll", detectCurrentAnchorContent, {
        passive: true
    });
    $(window).resize(function() {
        detectCurrentAnchorContent();
    });
};
var $7e9a5606323638c3$export$2e2bcd8739ae039 = $7e9a5606323638c3$var$anchorContent;

});

})();
//# sourceMappingURL=anchor-content.bd3fc3ce.js.map
